import { ConfigProvider, Switch } from "antd";
import React from "react";

const CustomSwitch = () => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Switch: {
            colorPrimary: "#32984D",
            colorPrimaryHover: "#32984D",
          },
        },
      }}
    >
      <Switch />
    </ConfigProvider>
  );
};

export default CustomSwitch;
